import * as ReselectModule from "reselect";
import { IAssistanceAddressListState } from ".";
import { IApplicationState } from "..";

export const selectAssistanceAddressList: ReselectModule.Selector<
  IApplicationState,
  IAssistanceAddressListState
> = (state) => state.assistanceAddressList;
